// src/app/core/mainPage/mainPagecomp/TopModelsSection/TopModelsSkeleton.tsx
export function TopModelsSkeleton() {
  return (
    <div className="px-4 py-6 mx-auto max-w-7xl animate-pulse">
      <div className="h-6 w-48 rounded bg-muted mb-4" />
      <div className="grid grid-cols-3 gap-3 mb-3">
        <div className="h-40 rounded-2xl bg-muted" />
        <div className="h-40 rounded-2xl bg-muted" />
        <div className="h-40 rounded-2xl bg-muted" />
      </div>
      <div className="h-44 rounded-2xl bg-muted" />
    </div>
  );
}